import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import axios, { AxiosInstance } from 'axios';
import { delete_cookie, read_cookie } from 'sfcookies';
import jwt_decode from 'jwt-decode';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';

import { Badge } from 'react-bootstrap';
import {
    Backdrop, CircularProgress, createTheme, InputAdornment, TextField, Tooltip,
} from '@mui/material';
import { UserDetailsI } from '../utiles/interfaces'
import { states, countries } from './constants'

const TOKEN = read_cookie('admin_pppcalc');
const BASE_URL = process.env.REACT_APP_BASE_URL;


export default function useUtils() {
    const user = (): UserDetailsI | null => {
        const userDetails: UserDetailsI | null = read_cookie('admin_pppcalc').length > 0 ?
            jwt_decode(read_cookie('admin_pppcalc') as string) : null

        return userDetails;
    }
    const yearsList = (): any[] => {
        const d = [];
        const thisYear = parseInt(new Date().toISOString().split('-')[0], 10);
        for (let x = thisYear; x > 1999; x--) {
            d.push({ payYear: x });
        }
        return d;
    }
    const capitalizeFirstCharacter = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1)
    const formatPhone = (phone: string | null | undefined) => {
        if (phone === null || phone === undefined) return '';
        const { length } = phone;
        if (length > 10) {
            switch (length) {
                case 11:
                    return (
                        `+${phone.slice(0, 1)
                        } (${phone.slice(1, 4)
                        }) ${phone.slice(4, 7)
                        } ${phone.slice(7, 11)}`
                    );
                case 12:
                    return (
                        `+${phone.slice(0, 2)
                        } (${phone.slice(2, 5)
                        }) ${phone.slice(5, 8)
                        } ${phone.slice(8, 12)}`
                    );
                case 13:
                    return (
                        `+${phone.slice(0, 2)
                        } (${phone.slice(2, 5)
                        }) ${phone.slice(5, 8)
                        } ${phone.slice(8, 12)}`
                    );
                default: return phone;
            }
        } else {
            return phone;
        }
    }
    const noValues = (): any[] => [null, 0, undefined, 'undefined', '0', '']
    const symbolDependingCurrencySelected = (country: string): string => {
        const currencySymbols = [
            { country: 'USA', symbol: '$' },
            { country: 'Mexico', symbol: 'MX$' },
            { country: 'Canada', symbol: 'CA$' },
            { country: 'Australia', symbol: 'AU$' },
            { country: 'India', symbol: '₹' },
            { country: 'Japan', symbol: '¥' },
        ];

        for (let x = 0; x < currencySymbols.length; x++) {
            const c = currencySymbols[x];
            if (c.country === country) {
                return c.symbol;
            }
        }
        return '$';
    }
    const currencyFormat = (value: any, country: string) => {
        if (!noValues().includes(value)) {
            let a: string = parseFloat(value).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });
            var ar: string[] = a.split('$');
            return `${symbolDependingCurrencySelected(country)} ${ar[1]}`;
        }
        return `${symbolDependingCurrencySelected(country)} 0.00`;
    }

    const axiosRequest = (): AxiosInstance => {
        axios.interceptors.response.use(
            response => {
                const { status } = response['data'];
                if (status == 403) {
                    delete_cookie('admin_pppcalc');
                    window.location.replace("");
                    return Promise.reject(response['data']);
                } else {
                    return response;
                }
            },
            function (error) {
                if (error.response.status === 403) {
                    delete_cookie('admin_pppcalc');
                    window.location.replace("");
                    return Promise.reject(error);
                } else {
                    return error && error['response'];
                }
                // return Promise.reject(error)
            }
        )

        const instance = axios.create({
            baseURL: BASE_URL,
            timeout: 30000,
            headers: { Authorization: `${TOKEN}` },
        })

        return instance;
    }



    const whatsapp = (tel: string, msg: string): string => {
        return `https://api.whatsapp.com/send?phone=${tel}&text=${encodeURI(msg)}`
    }
    const loadingScreen = (loading: boolean): React.ReactElement => {
        return (
            <Backdrop open={loading} style={{ zIndex: 50000 }} addEndListener={undefined}>
                <div className="text-center custom-loader">
                    <CircularProgress />
                </div>
            </Backdrop>
        );
    }
    const zeroPad = (num: string | number, places: number): string => String(num).padStart(places, '0')
    const isAdmin = (): any => read_cookie('anchor').length > 0 ? jwt_decode(read_cookie('anchor') as string) : {}
    const baseUrl = (): string | undefined => {
        return BASE_URL
    }
    const handleError = (msg: string): void => {
        if (process.env.ENVIROMENT !== 'Production') console.log(msg);
        if (msg?.toString().indexOf('Unauthorized') !== -1) {
            setTimeout(() => {
                alert('Session expired');
                delete_cookie('admin_pppcalc');
                window.history.replaceState('', '', '/');
                window.location.reload();
            }, 1000);
        } else if (msg.toString().indexOf('_UNIQUE') !== -1) {
            const emsg = msg.split('_');
            const field = emsg[0].split('.')[1];
            toast.error(
                `${field.toUpperCase()[0] + field.substr(1)} must be unique`,
            );
        } else if (msg.toString().indexOf('notEmpty') !== -1) {
            const emsg = msg.split(' ');
            toast.error(
                `${emsg[3].toUpperCase()[0] + emsg[3].substr(1)} cannot be empty`,
            );
        } else if (msg.toString().indexOf('isEmail') !== -1) {
            toast.error('Email is not valid');
        } else {
            toast.error(msg);
        }
    }
    const location = (country: string, state: string, city: string) => {
        let locationString = '';
        if (city !== null && city !== '') {
            locationString += city;
        }
        if (state !== null && state !== '') {
            locationString += `,${getStateAbbreviation(state)}`;
        }
        if (country !== null && country !== '') {
            locationString += `,${getCountryAbbreviation(country)}`;
        }
        if (locationString === '') {
            locationString = ' -- ';
        }
        return locationString;
    }
    const toastInstance = () => toast
    const getStateAbbreviation = (state: string): string | null => {
        for (let x = 0; x < states.length; x++) {
            if (state === states[x].state) {
                return states[x].abbreviation;
            }
        }
        return null;
    }
    const getCountryAbbreviation = (country: string): string | null => {
        for (let x = 0; x < countries.length; x++) {
            if (country === countries[x].country) {
                return countries[x].abbreviation;
            }
        }
        return null;
    }
    const swalCX = (title: string, text: string, icon: SweetAlertIcon, confirmButton: string) => {
        return Swal.fire({
            title: title,
            text: text,
            icon: icon,
            confirmButtonText: confirmButton
        });
    }
    const printPrettyDateTime = (dateString: string) => {
        console.log(dateString);
        const d = dateString.split('T')[0];
        const realData = humanDate(d);
        const time = dateString.split('T')[1].split('.')[0];
        return <>
            <div>{realData}</div>
            <div>{time}</div>
        </>;
    }
    const timeAgo = (dateString: string) => {
        return moment(dateString).fromNow();
    }
    const humanDate = (date: string, str = false, longStr = false): string => {
        if (date === null) return date;
        const d = date.split('T')[0].split('-');
        let month = d[1];
        if (str) {
            // Want name of the month instead of the number
            switch (d[1]) {
                case '01':
                    month = longStr ? 'January' : 'Jan';
                    break;
                case '02':
                    month = longStr ? 'February' : 'Feb';
                    break;
                case '03':
                    month = longStr ? 'March' : 'Mar';
                    break;
                case '04':
                    month = longStr ? 'April' : 'Apr';
                    break;
                case '05':
                    month = longStr ? 'May' : 'May';
                    break;
                case '06':
                    month = longStr ? 'June' : 'Jun';
                    break;
                case '07':
                    month = longStr ? 'July' : 'Jul';
                    break;
                case '08':
                    month = longStr ? 'August' : 'Aug';
                    break;
                case '09':
                    month = longStr ? 'September' : 'Sep';
                    break;
                case '10':
                    month = longStr ? 'October' : 'Oct';
                    break;
                case '11':
                    month = longStr ? 'November' : 'Nov';
                    break;
                case '12':
                    month = longStr ? 'December' : 'Dec';
                    break;
                default:
                    const [index1] = d;
                    month = index1;
                    break;
            }
        }
        return `${month}/${d[2]}/${d[0]}`;
    }


    return {
        user,
        yearsList,
        capitalizeFirstCharacter,
        formatPhone,
        noValues,
        symbolDependingCurrencySelected,
        currencyFormat,
        axiosRequest,
        whatsapp,
        loadingScreen,
        zeroPad,
        isAdmin,
        baseUrl,
        handleError,
        location,
        toastInstance,
        swalCX,
        printPrettyDateTime,
        timeAgo,
        humanDate,

    }
}